import { DirectiveBinding } from 'vue'

export default {
  bind(el: HTMLImageElement, binding: DirectiveBinding<{ fallBackImage?: string } | string>): void {
    try {
      const { value } = binding
      const fallBackImage = 'src/img/fall-back-image.png'
      const img = new Image()
      let error = fallBackImage
      const original = el.src
      if (typeof value === 'string') {
        error = value
      }
      if (value instanceof Object) {
        error = value.fallBackImage || fallBackImage
      }
      img.src = original
      img.onload = () => {
        el.src = original
      }
      img.onerror = () => {
        el.src = error
      }
    } catch (e) {
      console.log(e)
    }
  }
}